import axios from 'axios';
import { headers, getBackOfficeRoute } from './header';
import { ROLE_ADMIN } from '../../constants/roles';

const LongLocationWaitingUsersApiService = {

  getLongLocationWaitingUsers(token) {
    return axios
      .get(`${getBackOfficeRoute(ROLE_ADMIN)}/long-location-waiting-users`, {
        headers: headers(token),
      })
      .then((response) => response.data);
  },

  deleteLongLocationWaitingUsers(token, lldWaitingUserId) {
    return axios
      .delete(
        `${getBackOfficeRoute(ROLE_ADMIN)}/long-location-waiting-users/${lldWaitingUserId}`,
        {
          headers: headers(token),
        },
      )
      .then((response) => response.data);
  },
};

export default LongLocationWaitingUsersApiService;



// WEBPACK FOOTER //
// ./src/services/api/LongLocationWaitingUsersApiService.js